<template>
  <CContainer class="container-background-login" fluid>
    <loading 
      :active.sync="isLoading"
      loader="bars"
      color="#002bc6"
      background-color="#edf6fa"
    ></loading>
    <CRow class="d-flex content-center align-items-center min-vh-100">
      <CCol class="box-shadow" lg="9">
        <CCardGroup>
          <CCard>
            <CCardBody class="d-flex align-items-center justify-content-center bg-gradient-blue">
              <div class="center-image">
                  <img src="@/assets/images/logo-v.png" alt="Inergi.img">
              </div>                 
            </CCardBody>
          </CCard>
          <CCard class="p-4">
            <CCardBody>
              <CForm>
                <h2>INERGI AI BACKEND</h2>
                <p class="text-muted">Silahkan log in dengan akun Anda</p>
                <CInput
                  placeholder="Email"
                  v-model="email"
                  autocomplete="Email"
                  maxlength="50"
                >
                  <template #prepend-content>
                    <CIcon name="cil-user"/>
                  </template>
                </CInput>
                <CInput
                  placeholder="Password"
                  :type="unmaskedPassword ? 'input' : 'password' "
                  v-model="password"
                  maxlength="50"
                >
                  <template #prepend-content>
                    <CIcon name="cil-lock-locked"/>
                  </template>
                  <template #append-content>
                    <div class="unmasked-password width-100" @click="unmaskedPassword = !unmaskedPassword">                      
                      <CIcon :name="unmaskedPassword ? 'cil-lock-locked' : 'cil-lock-unlocked'"/>
                    </div>
                  </template>
                </CInput>
                <CRow class="justify-content-center">
                  <div class="text-left">
                    <CButton @click="submit($event)" color="info" class="px-4">Login</CButton>
                  </div>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCardGroup>
      </CCol>
      <CModal
        color="primary"
        :show.sync="showErrorModal" :centered="true">
        <div slot="header">{{modalTitle}}</div>
        <div class="">
          {{errorLabel}}
        </div>
        <div slot="footer">
          <CButton color="primary" @click="showErrorModal = false">OK</CButton>
        </div>
      </CModal>
    </CRow>
  </CContainer>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
  name: 'Login',
  components: {
    Loading
  },
  data(){
    return {
      isLoading: false,
      showErrorModal: false,
      modalTitle: '',
      email: '',
      unmaskedPassword: false,
      password: '',
      errorLabel: 'Maaf, Email/Password yang Anda masukan salah'
    }
  },
  methods: {
    submit(event){
      //do something
      event.preventDefault();
      this.isLoading = true;
      let processUrl = 'api/backend/v2/login';    
      this.$axios.post(processUrl, { email: this.email, password: this.password})
      .then((response) => {
        if(response.status == 200){
          if(response.data.success){
            localStorage.setItem(this.$appType+'emailUser', this.email);           
            sessionStorage.setItem('token', `Bearer ${response.data.data.access_token}`);
            this.isLoading = false;          
            this.$router.push({ name: 'Dashboard' });
          } else {
            this.modalTitle = 'Failed Authentication';
            this.errorLabel = response.data.message;
            this.isLoading = false;
            this.showErrorModal = true;
          }
        } else {
          this.errorAction(response);
        }
      })
      .catch((err) => {
        this.errorAction(err);
      })
    },
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.modalTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      this.isLoading =  false;
      this.showErrorModal = true;
    },
  },
  mounted(){
    this.$store.commit('setDefaultState', this.$store.state);
    localStorage.clear();
    sessionStorage.clear();
  }
}
</script>
<style>
</style>
